import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "../../DashboardLayout";
import { Button, Form, Table } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { fetchAdViewsBySessionLength } from "../../../services/axios/apiManager";
import { useNavigate } from "react-router-dom";
import { handleErrors } from "../../../services/dataManager";
import LoadingSpinner from "../../../Components/spinner";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function SessionLengthvsAdViews() {
  const tableRef = useRef(null);
  const navigate = useNavigate();
  const [userType, setUserType] = useState("");
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [fetching, setFetching] = useState(true);

  const getAdViewsBySessionLength = async () => {
    const res = await fetchAdViewsBySessionLength();
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
      if (userType) {
        const temp = res?.data?.data?.filter((f) => f.user_type === userType);
        setFilteredData(temp);
      } else {
        setFilteredData(res.data.data);
      }
    } else {
      handleErrors(res, navigate);
    }
    setFetching(false);
  };

  const handleFilterChange = (e) => {
    setUserType(e.target.value);
    if (e.target.value) {
      const temp = tableData?.filter((f) => f.user_type === e.target.value);
      setFilteredData(temp);
    } else {
      setFilteredData(tableData);
    }
  };
  const handleReset = () => {
    setUserType("");
    setFilteredData(tableData);
  };

  // Prepare chart data: two bars per user type
  const chartData = {
    labels: filteredData.map((item) => item?.user_type?.toUpperCase()),
    datasets: [
      {
        label: "Avg. Session Length (min)",
        data: filteredData.map((item) =>
          Math.floor(parseInt(item.avg_session_minutes))
        ),
        backgroundColor: "rgba(255, 206, 86, 0.6)",
      },
      {
        label: "Avg. Ads Watched",
        data: filteredData.map((item) => Math.floor(item.avg_ads)),
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { labels: { color: "#ffffff" } },
      tooltip: {
        callbacks: {
          label: (ctx) =>
            ctx.dataset.label.includes("Session")
              ? `${ctx.parsed.y} min`
              : `${ctx.parsed.y} ads`,
        },
      },
    },
    scales: {
      x: { ticks: { color: "#ffffff" } },
      y: {
        beginAtZero: true,
        ticks: { color: "#ffffff" },
      },
    },
  };

  useEffect(() => {
    getAdViewsBySessionLength();
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = filteredData.map((item) => {
      return [
        item.user_type,
        Math.floor(item.avg_session_minutes),
        Math.floor(item.avg_ads),
      ];
    });

    const config = {
      data: rows,
      columns: [
        { title: "User Type" },
        { title: "Avg. Session Length (min)" },
        { title: "Avg. Ads Watched" },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [filteredData]);

  return (
    <DashboardLayout>
      {/* Top Card: Header + Filter */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by User Type</h5>
          <div className="row align-items-center mb-3">
            <div className="col-md-3">
              <Form.Select
                className="bg-dark text-light border-light"
                value={userType}
                onChange={handleFilterChange}
              >
                <option value="">All user types</option>
                <option value="guest">Guest</option>
                <option value="registered">Registered</option>
              </Form.Select>
            </div>
            <div className="col-md-2">
              {fetching ? (
                <LoadingSpinner size="small" />
              ) : (
                <Button variant="success" onClick={handleReset}>
                  Reset
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Session Length vs. Ad Views</h5>
          <p className="card-text">
            Correlation between how long users play and how many ads they watch.
          </p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {/* <Table className="table-hover table-striped align-middle table-borderless table-dark mb-0">
              <thead>
                <tr>
                  <th>User Type</th>
                  <th>Avg. Session Length (min)</th>
                  <th>Avg. Ads Watched</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.user_type}</td>
                    <td>{Math.floor(item.avg_session_minutes)}</td>
                    <td>{Math.floor(item.avg_ads)}</td>
                  </tr>
                ))}
              </tbody>
            </Table> */}
            {filteredData.length === 0 && (
              <p className="text-muted mt-3">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Session Length & Ads Watched by User Type</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default SessionLengthvsAdViews;
